/* eslint-disable max-statements */
import React, {useState, useEffect} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
// import { LEAD_FORM_STEPS } from "./selector";
// import ArrowIcon from "../../shared/arrow";
// import Map from "./images/map.jpg";
// import IndiaLogo from "./images/india.svg";
import formatInputValue from "../../../utils/helpers/format-input-value";
import { SCREEN_NAMES } from "../pre-delivery-inspection-lead-form-parent/constant";
// import Button from "../../shared/button";
import PreDeliveryInspectionLocationWithLogin from "../pre-delivery-inspection-location-with-login";
// import RegCarDetailCard from "../../shared/reg-car-detail-card";
import { Modal } from "@cars24/turbo-web/lib/modal";
import { NUMBER } from "../../../constants/app-constants";
import Cross from "./images/cross.svg";
import { IconButton } from "@cars24/turbo-web/lib/icon-button";
import { Label } from "@cars24/turbo-web/lib/label";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { Chips } from "@cars24/turbo-web/lib/chips";
import { ButtonStack } from "@cars24/turbo-web/lib/button-stack";
import Car from "./images/car.svg";
import { Button } from "@cars24/turbo-web/lib/button";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Divider } from "@cars24/turbo-web/lib/divider";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { carDetailConfirm, carDetailEdit, userCategorySelect } from "../../../constants/tracking-constants/pre-delivery-inspection";
import IconSpinner from "../../shared/icon-spinner";

// eslint-disable-next-line complexity
const PreDeliveryInspectionConfirmCarDetailsScreen = ({
    preDeliveryInspectionLeadData,
    setFormActiveScreenConnect,
    setDetailsConnect,
    // isLoggedIn,
    getQuestionForUserIntentConnect = () => { },
    fetchModelImgConnect = () => { }
}) => {
    const { tokens } = useTokens();
    const [isOpen, setIsOpen] = useState(false);
    const [details, setDetails] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const {
        registrationNumber = "",
        newCarPdiLead,
        ownerName = "",
        brand = {},
        model = {},
        intent = {}
    } = preDeliveryInspectionLeadData || {};

    const { id: intentId = "" } = intent || {};
    const { name: brandName = "" } = brand || {};
    const { id: modelId = "", name: modelName = "" } = model || {};

    useEffect(() => {
        if (modelId) {
            getQuestionForUserIntentConnect().then((response) => {
                setDetails(response);
                fetchModelImgConnect(modelId).then((imageUrl) => {
                    setDetails({...response, imageUrl});
                    setIsLoading(false);
                }).catch(() => setIsLoading(false));
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelId]);

    const handleBack = () => {
        if (newCarPdiLead)setFormActiveScreenConnect(SCREEN_NAMES.vehicleInfoScreen);
        else setFormActiveScreenConnect(SCREEN_NAMES.mainFormScreen);
    };

    const handleIntent = async (text, id) => {
        setDetailsConnect({intent: {text, id}});
        await yieldToMain();
        sendCustomGaEvents({
            ...userCategorySelect,
            eventLabel: id
        });
    };

    const handleConfirm = async () => {
        setIsOpen(true);
        await yieldToMain();
        sendCustomGaEvents(carDetailConfirm);
    };

    const editStep = async ({index}) => {
        setDetailsConnect({
            activeAccordionStepIndex: index,
            activeFormScreen: newCarPdiLead ? SCREEN_NAMES.vehicleInfoScreen : SCREEN_NAMES.mainFormScreen
        });
        await yieldToMain();
        sendCustomGaEvents(carDetailEdit);
    };

    if (isLoading) return <div styleName={"styles.loadingIcon"}><IconSpinner/></div>;

    return (
        <React.Fragment>
            <div styleName={"styles.confirmCarDetails"}>
                <IconButton
                    size="small"
                    rounded={true}
                    onClick={() => handleBack()}
                >
                    <img src={Cross} alt="back"/>
                </IconButton>
                <Label level={NUMBER.TWO} fontWeight="semibold"  color={tokens.text_default_text_primary}>
                    {newCarPdiLead ? "Confirm new car details" : "Confirm used car details"}
                </Label>
            </div>
            <div>
                <div styleName={"styles.carImg"}>
                    <img src={details.imageUrl || Car} alt="Car" />
                </div>
                <div styleName={"styles.carInfo"}>
                    <div styleName={"styles.carInfoText"}>
                        {ownerName &&
                            <div styleName={"styles.infoText"}>
                                <BodyText level={NUMBER.THREE}>Owner’s name</BodyText>
                                <BodyText level={NUMBER.THREE} isBold={true}>{ownerName}</BodyText>
                            </div>
                        }
                        {brandName &&
                            <div styleName={"styles.infoText"}>
                                <BodyText level={NUMBER.THREE}>Car make and model</BodyText>
                                <BodyText level={NUMBER.THREE} isBold={true}>{brandName} {modelName}</BodyText>
                            </div>
                        }
                        {registrationNumber &&
                            <div styleName={"styles.infoText"}>
                                <BodyText level={NUMBER.THREE}>Registration no.</BodyText>
                                <BodyText level={NUMBER.THREE} isBold={true}>{formatInputValue(registrationNumber || "").toUpperCase()}</BodyText>
                            </div>
                        }
                    </div>

                    <Divider variant="primary" />

                    <div>
                        <Label level={NUMBER.FOUR} fontWeight="medium">{details.ques_text || ""}</Label>
                        <div styleName={"styles.carType"}>
                            {
                                (details.options || []).map(({
                                    ans_text: text = "",
                                    ans_id: id = ""
                                }) =>
                                    (<Chips
                                        key={id}
                                        label={text}
                                        onClick={() => handleIntent(text, id)}
                                        isActive={intentId === id}
                                        size="large"
                                    />)
                                )
                            }
                        </div>
                    </div>
                </div>
                <div styleName={"styles.buttonStack"}>
                    <ButtonStack layout="horizontal">
                        <Button
                            label={"Edit"}
                            variant={"tertiary"}
                            size="medium"
                            onClick={editStep}
                        />
                        <Button
                            label={"Confirm"}
                            onClick={handleConfirm}
                            size="medium"
                            disabled={!intentId}
                        />
                    </ButtonStack>
                </div>

            </div>
            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                showCloseButton={true}
                height={"628px"}
                width={"846px"}
            >
                <PreDeliveryInspectionLocationWithLogin
                    showInModal={false}
                    close={() => setIsOpen(false)}
                    setIsOpen={setIsOpen}
                    showClose={false}
                />
            </Modal>

            {/* <div styleName={"styles.modalWrap"}>
            <div styleName={"styles.modalSubWrapper"}>
                <div styleName={"styles.header"}>
                    <div styleName={"styles.map"}>
                        <img src={Map} alt="map" />
                    </div>
                    <div styleName={"styles.headerWrapper"}>
                        <div styleName={"styles.backIconWrapper"}>
                            <span styleName={"styles.close"} onClick={handleBack}>
                                <ArrowIcon black={true} rotateBy={90} />
                            </span>
                            {
                                registrationNumber &&
                                    <div styleName={"styles.registerNo"}>
                                        <img src={IndiaLogo} alt="india" />
                                        <span>{formatInputValue(registrationNumber || "").toUpperCase()}</span>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
                <div styleName={`styles.outer`}>
                    <p styleName={"styles.pageTitle"}>Confirm Car Details</p>
                    {
                        LEAD_FORM_STEPS.map(({ heading, key, isMandatory, icon }, index) => (
                            (isMandatory || (!isMandatory && preDeliveryInspectionLeadData[key] && preDeliveryInspectionLeadData[key].id)) &&
                                <React.Fragment key={key}>
                                    <RegCarDetailCard
                                        heading={heading}
                                        label={(preDeliveryInspectionLeadData[key] || {}).name}
                                        id={(preDeliveryInspectionLeadData[key] || {}).id}
                                        clickHandler={editStep}
                                        isEditable={true}
                                        index={index}
                                        icon={icon}
                                    />
                                </React.Fragment>
                        ))
                    }
                </div>
                <div styleName={"styles.buttonWrap"}>
                    <Button text={"CONFIRM"}
                        onClick={handleConfirm}
                    />
                </div>
            </div>*/}
        </React.Fragment>
    );
};

PreDeliveryInspectionConfirmCarDetailsScreen.propTypes = {
    preDeliveryInspectionLeadData: PropTypes.object,
    setFormActiveScreenConnect: PropTypes.func,
    setDetailsConnect: PropTypes.func,
    // isLoggedIn: PropTypes.bool,
    getQuestionForUserIntentConnect: PropTypes.func,
    fetchModelImgConnect: PropTypes.func
};

export default PreDeliveryInspectionConfirmCarDetailsScreen;
